module.exports = __webpack_public_path__ + "img/Docker.6dc1d846.png";